export const SET_EVENTS_LIST_LOADING = "events/list/loading"
export const SET_EVENTS_LIST_SUCCESS = "events/list/success"
export const SET_EVENTS_LIST_ERROR = "events/list/error"
export const SET_EVENTS_DETAIL_LOADING = "events/detail/loading"
export const SET_EVENTS_DETAIL_SUCCESS = "events/detail/success"
export const SET_EVENTS_DETAIL_ERROR = "events/detail/error"
